import { permissionAreaKeyNameOf } from "../../../helpers/permission.helpers";
import { SalesArea } from "../../../models/roles";
import { MenuMainNode } from "./nodes";

export function entityKeyResolver<T extends SalesArea>(name: Extract<keyof T, string>): string { return name; };

export const salesMenu: MenuMainNode = {
    icon: 'salesIconTemplate',
    title: 'Menu.Sales.Name',
    rootPath: '/sales-orders',
    areaPermissionKey: permissionAreaKeyNameOf('sales'),
    children: [
        {
            title: 'Menu.Sales.SalesOrders.Name',
            abbreviation: 'Menu.Sales.SalesOrders.Abbreviation',
            link: '/sales-orders',
            entityPermissionKey: entityKeyResolver("salesOrders"),
            isSubmenuPath: true,
        },
        {
            title: 'Menu.Sales.Quotes.Name',
            abbreviation: 'Menu.Sales.Quotes.Abbreviation',
            link: '/sales-orders/quotes',
            entityPermissionKey: entityKeyResolver("quotes")
        },
        {
            title: 'Menu.Sales.PriceCheck.Name',
            abbreviation: 'Menu.Sales.PriceCheck.Abbreviation',
            link: '/sales-orders/benefit-check',
            entityPermissionKey: entityKeyResolver("benefitCheck")
        },
        {
            title: 'Menu.Sales.EndOfDays.Name',
            abbreviation: 'Menu.Sales.EndOfDays.Abbreviation',
            link: '/sales-orders/end-of-days',
            entityPermissionKey: entityKeyResolver('endOfDays')
        }
    ]
};
